import { baseThemeVars } from './base-vars.css';
import { componentVars } from './component-vars.css';
import { smVars } from './semantic-vars.css';

export const themeVars = {
  ...baseThemeVars,
  color: {
    ...baseThemeVars.color,
    ...smVars,
  },
  ...componentVars,
};
